<template>
  <div v-title :data-title="$route.name">
    <div class="flex">
      <el-card style="width: 600px; max-height: 600px">
        <div class="mb_10 flex LH_input font_14 text_bold">
          <span class="mr_5" style="width: 150px">New Gallery</span>
          <el-input v-model="searchTypeName"></el-input>
          <el-button type="primary" size="small" @click="AddProType()"
            >Create</el-button
          >
        </div>
        <el-table
          border
          :header-cell-style="{
            background: '#1484D6',
            color: '#fff',
            padding: ' 5px 0',
          }"
          :data="DataTable"
          max-height="500px"
        >
          <el-table-column
            align="center"
            label="Gallery Type"
            prop="CaseTypeName"
          ></el-table-column>
          <el-table-column align="center" label="Action" width="220px">
            <template slot-scope="scope">
              <div class="flex">
                <span
                  class="underline mr_10 color_home pointer"
                  @click="EditName(scope.row)"
                  >Rename</span
                >
                <el-switch
                  @change="VoidName(scope.row.IsDelete, scope.row.CaseId)"
                  v-model="scope.row.IsDelete"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-text="Enable"
                  inactive-text="Disable"
                  :active-value="0"
                  :inactive-value="1"
                >
                </el-switch>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="Gallery Details">
            <template slot-scope="scope">
              <span
                :class="RowData.CaseId === scope.row.CaseId ? 'color_home' : ''"
                class="underline pointer"
                @click="getInformationData(scope.row)"
                >Edit</span
              >
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <el-card
        v-show="ShowInformation"
        class="text_left"
        style="min-width: 800px"
      >
        <div class="mb_10 flex text_bold">
          <span class="mr_5">Gallery Type:</span>
          <span>{{ RowData.CaseTypeName }}</span>
        </div>

        <div class="installadd">
          <el-row :gutter="24">
            <div
              style="background-color: #ddd"
              class="mt_20 pos_rel"
              v-for="(it, i) in UploadData"
              :key="i"
            >
              <el-col :span="6">
                <div style="margin-left: 20px" class="pos_rel">
                  <el-image
                    v-if="
                      it.ISImage &&
                      (it.FileFormat != '' || it.FileFormat != null)
                    "
                    :preview-src-list="UploadDataList"
                    style="width: 150px; height: 180px"
                    :src="it.FilePath"
                  />
                  <div
                    class="flex flex_around text_center"
                    v-else-if="it.FileFormat == '' || it.FileFormat == null"
                    style="width: 150px; height: 180px"
                  >
                    <div style="line-height: 1; color: #ccc">Error</div>
                  </div>
                  <video-player
                    v-else
                    class="video-player vjs-custom-skin mb_5"
                    style="width: 150px; height: 180px"
                    :options="{
                      sources: [
                        {
                          src: it.FilePath,
                        },
                      ],
                      height: '180px !important',
                      controls: true,
                      playbackRates: [0.5, 1, 1.5, 2],
                    }"
                  >
                  </video-player>
                  <el-checkbox
                    :true-label="1"
                    :false-label="0"
                    class="word-wrap"
                    @change="changeCheckbox(it)"
                    v-model="it.IsShow"
                    style="margin-left: 2px; max-width: 150px; display: flex"
                    >Show</el-checkbox
                  >
                  <i
                    @click="DeleteFile(it)"
                    style="
                      position: absolute;
                      top: -5px;
                      background: white;
                      border-radius: 10px;
                    "
                    class="el-icon-circle-close pos_icon font_18"
                  ></i>
                </div>
              </el-col>
            </div>

            <div>
              <el-upload
                class="upload-demo"
                :headers="headers"
                drag
                :show-file-list="false"
                action="/api/batteryplant/api/ProductAdmin/ProductAdminUploadFile"
                accept="image/*,video/*"
                :http-request="
                  (options) => {
                    UploadFile(options, 'Case');
                  }
                "
              >
                <div style="line-height: 50px; font-weight: 700">Add</div>
              </el-upload>
            </div>
          </el-row>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { get, post } from "../assets/api/api";
import {
  CaseAdminList,
  CaseList,
  CaseRegister,
  DeleteFile,
  ProductAdminUploadFile,
  UpdateIsShow,
  VoidRecoverCase,
} from "../assets/api/request";

export default {
  data() {
    return {
      searchTypeName: "",
      CaseId: 0,
      DataTable: [],
      RowData: {
        CaseTypeName: "",
      },
      headers: {
        token: sessionStorage.getItem("token"),
      },
      ShowInformation: false,
      UploadData: [],
      UploadDataList: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 添加修改Case类型
    AddProType() {
      if (!this.searchTypeName) {
        this.$message.error("Please enter Type Name");
        return;
      }
      this.$confirm("Are you sure to continue?", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      }).then(() => {
        let data = {
          CaseId: this.CaseId,
          CaseTypeName: this.searchTypeName,
        };
        post(CaseRegister, data).then((res) => {
          if (res.data.code === 200) {
            this.getData();
            this.CaseId = 0;
            this.$message.success("Successful.");
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    getData() {
      get(CaseList).then((res) => {
        this.DataTable = res.data.data;
      });
    },
    EditName(row) {
      this.CaseId = row.CaseId;
      this.searchTypeName = row.CaseTypeName;
    },
    VoidName(type, id) {
      this.$confirm("Are you sure to continue?", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      })
        .then(() => {
          get(VoidRecoverCase + "?CaseId=" + id + "&IsDelete=" + type).then(
            (res) => {
              if (res.data.code === 200) {
                this.$message.success("Successful.");
              } else {
                this.$message.error(res.data.msg);
              }
            }
          );
        })
        .finally(() => {
          this.getData();
        });
    },
    getInformationData(row) {
      this.RowData = row;
      this.ShowInformation = true;
      this.getFileList();
    },
    // 上传文件
    UploadFile(options, type) {
      let formdata = new FormData();
      formdata.append("file", options.file);
      // console.log(options);

      axios({
        method: "POST",
        url: ProductAdminUploadFile,
        params: {
          ToCaseId: this.RowData.CaseId,
          ToProductId: 0,
          FileType: type,
          FileFormat: options.file.type,
        },
        data: formdata,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success("Successful");
          this.getFileList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 分类文件列表
    getFileList() {
      get(CaseAdminList + "?ToCaseId=" + this.RowData.CaseId).then((res) => {
        this.UploadData = res.data.caseJson;
        this.UploadDataList = [];

        this.UploadData.forEach((item) => {
          this.UploadDataList.push(item.FilePath);

          item.ISImage =
            item.FileFormat && item.FileFormat.split("/")[0] === "image";
        });
      });
    },
    // 删除文件
    DeleteFile(data) {
      this.$confirm("Are you sure to continue?", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      }).then(() => {
        get(DeleteFile + "?FileId=" + data.FileId).then((res) => {
          if (res.data.code === 200) {
            this.getFileList();
            this.$message.success("Successful.");
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 勾选取消
    changeCheckbox(data) {
      get(
        UpdateIsShow + "?FileId=" + data.FileId + "&IsShow=" + data.IsShow
      ).then((res) => {
        if (res.data.code === 200) {
          this.getFileList();
          this.$message.success("Successful");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
.installadd >>> .el-upload-dragger {
  background-color: #2d8eff;
  color: #fff;
  /* border: 1px dashed #d9d9d9; */
  border-radius: 25px;
  box-sizing: border-box;
  width: 50px;
  height: 50px;
  /* text-align: center; */
  /* cursor: pointer; */
  position: relative;
  overflow: hidden;
}
.el-checkbox,
.el-checkbox__label {
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
}
</style>
